/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class Subject {
  baseApi = ENV.BASE_API;

  async getSubjects(accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.SUBJECT}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createSubject(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.SUBJECT}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateSubject(accessToken, subjectId, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.SUBJECT}/${subjectId}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteSubject(accessToken, subjectId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.SUBJECT}/${subjectId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
